// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemIcmsColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import financialService from 'services/financialService';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the ICMS tax value column for item subtables.
function itemIcmsColumn(options = {}) {
  const { size, ..._ } = options;
  const fontSize = resolveItemFontSize(size, 10);
  return {
    title: 'ICMS',
    dataIndex: ['tax', 'icms', 'value'],
    width: 60,
    align: 'right',
    sorter: (a, b) => {
      const aVal = a?.tax?.icms?.value || a?.icms || 0;
      const bVal = b?.tax?.icms?.value || b?.icms || 0;
      return aVal - bVal;
    },
    render: (_, item) => {
      const icms = item?.tax?.icms?.value || item?.icms;
      if (!icms) {
        return (
          <Text style={{ fontSize }} type="secondary">
            —
          </Text>
        );
      }
      return (
        <Text style={{ fontSize }} type="secondary">
          {financialService.formatCurrency(icms)}
        </Text>
      );
    },
  };
}

export default itemIcmsColumn;
